import "./about.css";

export default function About() {
  return (
    <div id="about">
      <div className="a-left">
        <div className="a-card">
          <img src="images/profile.png" alt="" />
        </div>
      </div>
      <div className="a-right">
        <div className="a-title">About Me</div>
        <div className="a-desc">
          I am a web developer familiar with full-stack JavaScript and PHP, especially with React Js, Next Js, Node Js, and Laravel frameworks. I have more than
          2 years of experience in the industrial world. Currently, I am still actively working at an IT company in South Jakarta since October 2022.
          <br /> <br />
          I graduated from Engineering Physics at Gadjah Mada University with GPA 3.28. Coding has been my passion and hobby since my college days. I learned to
          code independently through courses and tutorials, studying programming and practicing every day.
          <br /> <br />
          I have completed many courses and worked on numerous projects with different teams. With my current abilities, I am confident that I can solve all of
          your problems.
          <br /> <br />
          So, what are you waiting for? Please <a href="#contact">contact</a> me right now!
        </div>
      </div>
    </div>
  );
}
